import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	AdminUsersResponse,
	AdminUsersSearch,
	ServerDataResponse
} from '@models/models';
import { Observable } from 'rxjs/Observable';
import { AdminTwoFaUserInfo } from '@models/two-fa.models';
import {
	AccessInfo,
	FreeAccessResponse,
	SubscriptionInfoStatus
} from '@models/subscription.model';

@Injectable()
export class AdminUsersDataService {
	private ADMIN_URL = '/api/admin';

	constructor(private http: HttpClient) {}

	getUserSubscription(email: string) {
		const url = `${this.ADMIN_URL}/user/`;
		return this.http.post(url, email);
	}

	synchronize(): Observable<any> {
		const url = `${this.ADMIN_URL}/synchronize-admin-table-data`;
		return this.http.get(url);
	}

	deleteUser(email: string): Observable<any> {
		const url = `${this.ADMIN_URL}/user/delete`;
		const params: HttpParams = new HttpParams().append('userEmail', email);
		return this.http.delete(url, { params });
	}

	getUsers(data: AdminUsersSearch): Observable<AdminUsersResponse> {
		const url = `${this.ADMIN_URL}/get-admin-table-data`;
		return this.http.post(url, data).map((res: any) => res.data);
	}

	getUserTwoFaInfo(
		accountId: string
	): Observable<ServerDataResponse<AdminTwoFaUserInfo>> {
		const url = `${this.ADMIN_URL}/accounts/${accountId}/users/2fa`;
		return this.http.get(url) as Observable<
			ServerDataResponse<AdminTwoFaUserInfo>
		>;
	}

	giveFreeAccess(
		timeConfiguration,
		businessAccountId: string,
		freeAccessMethod: string
	): Observable<ServerDataResponse<FreeAccessResponse>> {
		const url = `${this.ADMIN_URL}/accounts/${businessAccountId}/${
			freeAccessMethod === 'PRORATABLE'
				? 'adjust/free-time'
				: 'give/free-access'
		}`;

		return this.http.post<ServerDataResponse<FreeAccessResponse>>(
			url,
			timeConfiguration
		);
	}

	closeAccess(
		businessAccountId
	): Observable<ServerDataResponse<FreeAccessResponse>> {
		const url = `${
			this.ADMIN_URL
		}/accounts/${businessAccountId}/subscriptions/close-access`;
		return this.http.post<ServerDataResponse<FreeAccessResponse>>(url, {});
	}

	getSubscriptionInfo(
		user
	): Observable<ServerDataResponse<SubscriptionInfoStatus>> {
		const url = `${this.ADMIN_URL}/accounts/${
			user.businessAccountId
		}/subscriptions/details`;
		return this.http.post<ServerDataResponse<SubscriptionInfoStatus>>(url, {});
	}

	getSubscriptionInfoForFreeAccess(
		user
	): Observable<ServerDataResponse<AccessInfo>> {
		const url = `${this.ADMIN_URL}/accounts/${
			user.businessAccountId
		}/subscriptions/status`;
		return this.http.post<ServerDataResponse<AccessInfo>>(url, {});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/services/admin/users/admin-users.data.service.ts